import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Children, cloneElement, isValidElement } from 'react';
import { getRevOsRenameCopyChangeKey } from '../utils/copyChangeUtils';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * @internal
 * Copies and modifies the message prop of child components, i.e. FormattedMessage, FormattedJSXMessage, etc.
 *
 * @param children - The child components to modify.
 * @param messageModifier - A function that modifies the message key.
 * @returns The child components where the `message` prop is modified
 */
export function CopyChange({
  children,
  messageModifier = key => key
}) {
  return /*#__PURE__*/_jsx(_Fragment, {
    children: Children.map(children, child => {
      if ( /*#__PURE__*/isValidElement(child) && (child.type === FormattedMessage || child.type === FormattedJSXMessage || child.type === FormattedHTMLMessage || child.type === FormattedReactMessage || 'message' in child.props && typeof child.props.message === 'string')) {
        const newProps = Object.assign({}, child.props, {
          message: messageModifier(child.props.message)
        });
        return /*#__PURE__*/cloneElement(child, newProps);
      }
      return child;
    })
  });
}
export function RevOsRenameCopyChange({
  children,
  isRevOsRenamed
}) {
  return /*#__PURE__*/_jsx(CopyChange, {
    messageModifier: key => getRevOsRenameCopyChangeKey(key, isRevOsRenamed),
    children: children
  });
}